export default {
  language: 'Jazyk',
  navigation: {
    home: 'Domů'
  },
  welcome: {
    title: 'Vítejte v Generátoru bludišť',
    generateButton: 'Generovat bludiště'
  },
  generate: {
    title: 'Generátor bludišť',
    difficulty: 'Obtížnost',
    difficulties: {
      easy: 'Lehká',
      medium: 'Střední',
      hard: 'Těžká'
    },
    themes: {
      label: 'Témata',
      space: 'Vesmír',
      fantasy: 'Fantasy',
      animals: 'Zvířata'
    },
    regenerateButton: 'Přegenerovat bludiště',
    downloadButton: 'Stáhnout PDF'
  }
}